import { createContext } from 'preact'
import { BlockMapping } from './interfaces'

export type BlockTreeContextValue = BlockMapping

export const BlockTreeContext = createContext<BlockTreeContextValue>({})

if (process.env.NODE_ENV !== 'production') {
  BlockTreeContext.displayName = 'BlockTreeContext'
}
